import { connect } from 'react-redux';
import { compose } from 'recompose';

import FormWrapper from './FormWrapper';
import { QuerySingleTicketGQL } from '../graphql';
/* NOTE: flag to show modal, function to close modal */
import {
  closeTicketEntryForm,
} from '../actions';

import { getShowModalFlag } from '../selectors';

const mapStateToProps = (state) => {
  return {
    showTicketEntryFormModal: getShowModalFlag(state),
  };
};

const mapDispatchToProps = {
  closeTicketEntryForm,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  QuerySingleTicketGQL,
);

export default enhance(FormWrapper);
